import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { BUSINESS_TERM_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';
import { useHeadOfHouseholdMaxTargetScoreAgeGroup } from '../../../TargetScore';
import { getBtBreakpointsFromAgeGroup } from './util';

export function ClientBusinessTermScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  const { ageGroup, isHeadOfHouseholdMaxAgeLoading } = useHeadOfHouseholdMaxTargetScoreAgeGroup({
    firmID: props.firmID,
    firmClientID: props.firmClientID,
  });

  return (
    <ClientScoreHealthRange
      {...props}
      element={BUSINESS_TERM_SCORECARD_ELEMENT_SYMBOL}
      externalLoading={isHeadOfHouseholdMaxAgeLoading}
      breakpoints={getBtBreakpointsFromAgeGroup(ageGroup)}
    />
  );
}
